import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;
const FormItem = Form.Item;

export const OPCOES_COR = [
  { key: '#FFFFFF', label: 'BRANCO', color: '#FFFFFF' },
  { key: '#cfcfcf', label: 'CINZA', color: '#cfcfcf' },
  { key: '#829dff', label: 'AZUL', color: '#829dff' },
  { key: '#7bf9f4', label: 'CIAN', color: '#7bf9f4' },
  { key: '#9efdb6', label: 'VERDE', color: '#9efdb6' },
  { key: '#fe9f9f', label: 'VERMELHO', color: '#fe9f9f' },
  { key: '#fe9151', label: 'LARANJA', color: '#fe9151' },
  { key: '#F5F6CE', label: 'AMARELO', color: '#F5F6CE' },
  { key: '#bb98ec', label: 'ROXO', color: '#bb98ec' },
]


export default class TipoAgendaForm extends Component {
  state = {
    registro: {
      ta_idf: 0,
      ta_descricao: '',
      ta_cor: { key: '#FFFFFF', label: "" }
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {

      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };




  onOK = () => {
    if ((!this.state.registro.ta_descricao) || (this.state.registro.ta_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    const reg = {
      ta_idf: this.state.registro.ta_idf,
      ta_descricao: this.state.registro.ta_descricao,
      ta_cor: this.state.registro.ta_cor.key,
    }

    this.props.onSalvarClick(reg);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { ta_idf, ta_descricao, ta_cor } = this.state.registro;

    return (
      <Modal
        title={ta_idf ? "Edição de Tipo de Agenda" : "Cadastro de Tipo de Agenda"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição *</span>
              <InputForm
                id="ta_descricao"
                ref="ta_descricao"
                maxLength={60}
                onChange={this.onChange}
                value={ta_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={24} >
              <span>Cores</span>
              <InputForm
                type="select"
                id="ta_cor"
                ref="ta_cor"
                value={ta_cor}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COR}
                validator={value => Boolean(value)}
                style={{ width: "100%", }}//dropdownStyle: ta_cor ? ta_cor : "#FFFFFF" }}
                dropdownStyle={{ color: "#b95e5e"}}
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TipoAgendaForm.js